module.exports = __webpack_public_path__ + "static_pc/img/7.8b90cf49.png";